import { inject, observer } from "mobx-react";
import { useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Link,
  Divider,
} from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import "./update.scss";

const updatText = [
  {
    data: "1/9/2022. v1.2.2",
    Added: ["Added the Tutorial with more detailed methods and typo fixed."],
    Changed: ["Front-end text and images"],
    Fixed: [],
  },

  {
    data: "1/8/2022. v1.2.1",
    Added: [
      "Added Upset plot",
      "Front-end display of methylation and functional logic.",
    ],
    Changed: ["Hardware upgrade", "Changed the intranet penetration method."],
    Fixed: [
      "Modified the problem of intranet and extranet access failure of education network.",
    ],
  },
  {
    data: "15/6/2022. v1.2",
    Added: ["Added functional annotation prediction."],
    Changed: [],
    Fixed: [],
  },
  {
    data: "1/5/2022. v1.1.4",
    Added: ["Added VN plots to the results analysis.", "Added cdhit method."],
    Changed: ["Modified the front-end display."],
    Fixed: ["Modified the front-end options incomplete issue."],
  },

  {
    data: "26/3/2022. v1.1.3",
    Added: [
      "Added comparison with 5 classical traditional feature extraction methods.",
      "Added comparative histogram of result indicators for multiple methods.",
    ],
    Changed: ["Refactored the code for dataset loading."],
    Fixed: [],
  },
  {
    data: "23/2/2022. v1.1.2",
    Added: [
      "Added a variety of deep learning methods for NLP.",
      "Added deep learning methods based on graph networks.",
      "Added examples for display.",
    ],
    Changed: ["Modified the puzzle logic of the umap and shap charts."],
    Fixed: [],
  },
  {
    data: "13/12/2021. v1.1.1",
    Added: ["Added motif for dataset analysis.", "Added examples for display."],
    Changed: ["Modified the naming logic of jobid."],
    Fixed: [],
  },

  {
    data: "17/11/2021. v1.1",
    Added: [
      "Added the function of comparing multiple models.",
      "Added analysis of the dataset itself.",
    ],
    Changed: [
      "Modified all result visualizations to multiple model comparison visualizations.",
      "Optimized and unified the color scheme of all visualizations.",
      "The visualization results are categorized: dataset analysis, result analysis, feature analysis.",
    ],
    Fixed: [],
  },
  {
    data: "6/11/2021. v1.0.2",
    Added: [
      "Added some visualization for feature analysis.",
      "including UMAP and SHAP, Added new overview figure.",
    ],
    Fixed: [
      "Fixed the problem that emails could not be sent due to excessive amount of emails sent.",
      "Fixed the problem that some models could not be feature analyzed.",
    ],
    Changed: ["Optimized interface interaction logic."],
  },
  {
    data: "19/10/2021. v1.0.1",
    Added: [
      "Several deep learning methods were added, such as TextCNN.",
      "Added epoch visualization.",
      "Added email alert function.",
    ],
    Changed: ["Optimized interface interaction logic."],
    Fixed: [],
  },
  {
    data: "1/10/2021. v1.0",
    Added: [
      "We are excited to present you the DeepBIO server 1.0! Please feel free to contact us if you encounter any issues.",
    ],
    Changed: [],
    Fixed: [],
  },
];

function updateComponent(data) {
  return (
    // <Container className="ref-body"  maxWidth="xl">
    <Grid container spacing={2}>
      <Grid
        item
        md={12}
        sm={12}
        xs={12}
        container
        direction="column"
        spacing={4}
      >
        <Grid item>
          <CardContent sx={{ ml: 2 }}>
            <Card sx={{ minWidth: 300, borderLeft: "6px solid #f6903d" }}>
              <CardContent sx={{ ml: 2 }}>
                <Container>
                  <Typography
                    variant="h3"
                    component="div"
                    color="black"
                    sx={{ fontSize: "18px", fontWeight: "bold", mb: 1, mt: 3 }}
                  >
                    {data.data}
                  </Typography>
                </Container>
                <Divider></Divider>
                {data.Added.length > 0 && (
                  <Grid item sx={{ mt: 2 }}>
                    <Container>
                      <Typography
                        variant="h4"
                        color="primary"
                        component="div"
                        sx={{ color: "black", fontSize: "18px", ml: 1.5 }}
                      >
                        {" "}
                        Added:
                      </Typography>
                      {data.Added.map((value, index, array) => {
                        return (
                          <Typography
                            variant="h6"
                            color="primary"
                            component="div"
                            sx={{ color: "black", fontSize: "18px" }}
                          >
                            <FiberManualRecord
                              sx={{ color: "black", fontSize: "14px" }}
                            />
                            <> </>
                            {value}
                          </Typography>
                        );
                      })}
                    </Container>
                  </Grid>
                )}

                {data.Fixed.length > 0 && (
                  <Grid item sx={{ mt: 2 }}>
                    <Container>
                      <Typography
                        variant="h4"
                        color="primary"
                        component="div"
                        sx={{ color: "black", fontSize: "18px", ml: 1.5 }}
                      >
                        Fixed:
                      </Typography>
                      {data.Fixed.map((value, index, array) => {
                        return (
                          <Typography
                            variant="h6"
                            color="primary"
                            component="div"
                            sx={{ color: "black", fontSize: "18px" }}
                          >
                            {" "}
                            <FiberManualRecord
                              sx={{ color: "black", fontSize: "14px" }}
                            />
                            <> </>
                            {value}
                          </Typography>
                        );
                      })}
                    </Container>
                  </Grid>
                )}
                {data.Changed.length > 0 && (
                  <Grid item sx={{ mt: 2 }}>
                    <Container>
                      <Typography
                        variant="h4"
                        color="primary"
                        component="div"
                        sx={{ color: "black", fontSize: "18px", ml: 1.5 }}
                      >
                        {" "}
                        Changed:
                      </Typography>
                      {data.Changed.map((value, index, array) => {
                        return (
                          <Typography
                            variant="h6"
                            color="primary"
                            component="div"
                            sx={{ color: "black", fontSize: "18px" }}
                          >
                            {" "}
                            <FiberManualRecord
                              sx={{ color: "black", fontSize: "14px" }}
                            />
                            <> </>
                            {value}
                          </Typography>
                        );
                      })}
                    </Container>
                  </Grid>
                )}
              </CardContent>
            </Card>
          </CardContent>
        </Grid>
      </Grid>
    </Grid>
    // </Container>
  );
}
//name  link author book doi PDF
function Update(store) {
  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);
  return (
    <Container className="ref-body" maxWidth="xl">
      <Box className="ref-title" color="primary.light">
        <Typography variant="h3" component="div" className="ref-title-text">
          What's new
        </Typography>
      </Box>
      <Box>{updatText.map((v) => updateComponent(v))}</Box>
    </Container>
  );
}

export default inject("store")(observer(Update));
